module.exports = __webpack_public_path__ + "static/media/dotnet-icon.65dd0b59.png";